// @ts-nocheck
import InvoiceHistoryReducer from "@insite/client-framework/Store/Pages/InvoiceHistory/InvoiceHistoryReducer";
import OrderHistoryReducer from "@insite/client-framework/Store/Pages/OrderHistory/OrderHistoryReducer";
import AccountSettingsReducer, {
    GreifAccountSettingsPageReducer,
} from "@store/Framework/Store/Greif/Pages/AccountSettings/AccountSettingsReducer";
import CartReducer, { GreifPagesCartActions } from "@store/Framework/Store/Greif/Pages/Cart/CartReducer";
import checkoutShippingReducer, {
    GreifPagesCheckoutShippingActions,
} from "@store/Framework/Store/Greif/Pages/CheckoutShipping/CheckoutShippingReducer";
import ContactUsReducer, {
    GreifContactUsPageReducer,
} from "@store/Framework/Store/Greif/Pages/ContactUs/ContactUsReducer";
import FeatureNotesListReducer, {
    GreifFeatureNotesPagesActions,
} from "@store/Framework/Store/Greif/Pages/FeatureNotesList/FeatureNotesListReducer";
import RequestOrderChangeReducer, {
    GreifOrderChangePagesActions,
} from "@store/Framework/Store/Greif/Pages/RequestOrderChange/RequestOrderChangeReducer";
import RequestOrderComplaintReducer, {
    GreifOrderComplaintPagesActions,
} from "@store/Framework/Store/Greif/Pages/RequestOrderComplaint/RequestOrderComplaintReducer";
import ResetPasswordReducer, {
    GreifOrderResetPasswordPageActions,
} from "@store/Framework/Store/Greif/Pages/ResetPassword/ResetPasswordReducer";
import ReviewAndSubmitReducer, {
    GreifPagesSubmitAndReviewActions,
} from "@store/Framework/Store/Greif/Pages/ReviewAndSubmit/ReviewAndSubmitReducer";
import ShipmentHistoryReducer, {
    GreifShipmentHistoryPageActions,
} from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryReducer";
import TaxExemptionCertificatesReducer, {
    GreifTaxExemptionCertificatesPagesActions,
} from "@store/Framework/Store/Greif/Pages/TaxExemptionCertificates/TaxExemptionCertificatesReducer";
import TECNotificationReducer, {
    GreifTECNotificationPagesActions,
} from "@store/Framework/Store/Greif/Pages/TECNotification/TECNotificationReducer";
import TrailerTrackingReducer, {
    GreifTrailerTrackingPageActions,
} from "@store/Framework/Store/Greif/Pages/TrailerTracking/TrailerTrackingReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    checkoutShipping: checkoutShippingReducer,
    orderHistory: OrderHistoryReducer,
    invoiceHistory: InvoiceHistoryReducer,
    orderComplaint: RequestOrderComplaintReducer,
    taxExemptionCertificates: TaxExemptionCertificatesReducer,
    cart: CartReducer,
    reviewAndSubmit: ReviewAndSubmitReducer,
    tecContactSupport: TECNotificationReducer,
    orderChange: RequestOrderChangeReducer,
    contactUs: ContactUsReducer,
    accountSettings: AccountSettingsReducer,
    featureNotesList: FeatureNotesListReducer,
    resetPassword: ResetPasswordReducer,
    shipmentHistory: ShipmentHistoryReducer,
    trailerTracking: TrailerTrackingReducer,
};

export type GreifPagesActions =
    | GreifPagesCartActions
    | GreifPagesCheckoutShippingActions
    | GreifOrderComplaintPagesActions
    | GreifTaxExemptionCertificatesPagesActions
    | GreifTECNotificationPagesActions
    | GreifPagesSubmitAndReviewActions
    | GreifOrderChangePagesActions
    | GreifContactUsPageReducer
    | GreifAccountSettingsPageReducer
    | GreifFeatureNotesPagesActions
    | GreifOrderResetPasswordPageActions
    | GreifShipmentHistoryPageActions
    | GreifTrailerTrackingPageActions
    | GreifOrderResetPasswordPageActions;
export default combineReducers(pagesReducers);
